import React from "react";
import { useWatchState, handler, useModal } from "@/store";
import { Avatar } from "@/components";
import { avatar } from "@/common";
import logo from "./images/push-logo.png";
import { Dropdown, Menu } from "antd";
import logoDark from "./images/push_logo_dark.png";
import "./style.less";
import { Link } from "react-router-dom";

function CourseHead({ theme = "hight", className = "" }) {
  const [[i18n]] = useWatchState(["i18n"]);
  const [[UPLOAD_SERVER_HOST = ""]] = useWatchState(["$_UPLOAD_SERVER_HOST"]);
  const [[{ IS_LOGIN, info = {} }]] = useWatchState(["user"]);
  const [userSetModal] = useModal(["userSet"]);

  const menu = (
    <Menu>
      <Menu.Item>
        <span onClick={userSetModal.show.later({ UPLOAD_SERVER_HOST })}>
          {i18n.home.user.settings}
        </span>
      </Menu.Item>
      <Menu.Item>
        <span onClick={handler.logout}>{i18n.home.user.logOut}</span>
      </Menu.Item>
    </Menu>
  );

  return (
    <header
      className={`module-pushHead module-pushHead--${theme} flex ver between ${className}`}
    >
      <div className="module-pushHead__title bold color-706be8 flex ver child-left-sm">
        <img src={logo} className="h-40-px" alt="" />
        <p className="nowrap">{i18n.push.title}</p>
      </div>
      <div className="flex ver child-left-md">
      <a href="http://www.tianhe-cloud.com/#/forum"   className="link">        
           <span>{i18n.push.home}</span>
        </a>
        {IS_LOGIN ? (
          <div className="child-left-sm flex ver">
            <Dropdown className="child-left-md" overlay={menu}>
              <a className="link">{info.nickname || info.account}</a>
            </Dropdown>
            <Avatar
              width="30px"
              url={avatar(info.avatar, UPLOAD_SERVER_HOST)}
              className="border-white"
            />
          </div>
        ) : (
          <div className="child-left-sm">
            <Link to="/login">{i18n.home.user.login}</Link>
            <span>|</span>
            <Link to="/register">{i18n.home.user.register}</Link>
          </div>
        )}
      </div>
    </header>
  );
}

export default CourseHead;
